import Hr from 'ui/atoms/Hr/Hr';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';
import PropTypes from 'prop-types';
import React from 'react';

function MaterialPreviewQuestion({ material }) {
  const question = typeof material.content_data === 'string' ? JSON.parse(material.content_data) : material.content_data;

  return (
    <div className="mt-3">
      <Hr />

      <div className="mt-3">
        <TextHtml isAuthored text={question?.data?.stimulus} />
      </div>
    </div>
  );
}

MaterialPreviewQuestion.propTypes = {
  material: PropTypes.shape({
    content_data: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  }).isRequired,
};

export default MaterialPreviewQuestion;
